import { z } from '@hono/zod-openapi'

export const selfWithdrawalBlockReasonSchema = z.enum([
  'ACTIVE_TICKET',
  'UNPAID_TUITION',
  'PAYMENT_FAILURE',
  'RESERVED_LESSON',
  'TRIAL_RESERVATION',
  'OPEN_INQUIRY',
  'SCHEDULED_PAYMENT',
  'TUTOR_ACCOUNT',
  'VALIDATION_UNAVAILABLE',
])

export const selfWithdrawalEvidenceSchema = z.object({
  activeTicketCount: z.number(),
  unpaidTuitionAmount: z.number(),
  paymentFailureCount: z.number(),
  reservedLessonCount: z.number(),
  trialReservationCount: z.number(),
  openInquiryCount: z.number(),
  scheduledPaymentCount: z.number(),
  tutorAccountLinked: z.boolean(),
})

export const selfWithdrawalEligibilitySchema = z.object({
  eligible: z.boolean(),
  reasons: z.array(selfWithdrawalBlockReasonSchema),
  evidence: selfWithdrawalEvidenceSchema,
})

export const selfWithdrawalFailureSchema = z.enum(['WITHDRAWAL_IN_PROGRESS', 'PROCESSING_FAILED'])

export const selfWithdrawalExecutionSchema = z.object({
  withdrawn: z.boolean(),
  eligibility: selfWithdrawalEligibilitySchema.nullable(),
  failure: selfWithdrawalFailureSchema.nullable(),
})

export type SelfWithdrawalBlockReason = z.infer<typeof selfWithdrawalBlockReasonSchema>
export type SelfWithdrawalEligibility = z.infer<typeof selfWithdrawalEligibilitySchema>
export type SelfWithdrawalExecution = z.infer<typeof selfWithdrawalExecutionSchema>
